export default __webpack_public_path__ + "static/media/CCR.42df987c.txt";